import type { PermissionState } from "@kontextwerk/control-web-frame/shared/logic/authorization"
import type {
  LevelOption,
  PermissionLevel,
  PermissionRowConfig,
  ScopeOption,
} from "../../../../../../../../../../../_shared/_logic/permission-sections"

/**
 * Offers only grants within the editor's own confirmed ceiling, plus the stored value so it
 * stays visible. Presentation only: the server rejects any grant beyond the ceiling.
 */
export const delegableLevelOptions = (
  row: PermissionRowConfig,
  permissions: PermissionState,
  current: PermissionLevel | undefined,
): LevelOption[] =>
  row.levelOptions.filter(
    (option) =>
      option.value === "none" ||
      option.value === current ||
      permissions.allows(row.key, option.value),
  )

export const delegableScopeOptions = (
  row: PermissionRowConfig,
  permissions: PermissionState,
  level: PermissionLevel | undefined,
  current: string | null | undefined,
): ScopeOption[] =>
  (row.scopeOptions ?? []).filter(
    (option) =>
      option.value === current ||
      (level !== undefined &&
        level !== "none" &&
        permissions.allows(row.key, level, { scope: option.value })),
  )
